// extracted by mini-css-extract-plugin
module.exports = {"propertiesItem":"property-detail-label_propertiesItem__CJRox","propertiesLabel":"property-detail-label_propertiesLabel__kyBpW"};